export const tenantId = '2edaeb8d-8b0c-4891-b7dc-8c1a333f25c0';
export const clientId = '40ba1224-2b08-4abe-9845-31799a231f02';
export const version = '0.0.3';
export const apiUrl = 'https://coc00napi-test.azurewebsites.net/api/';
export const apiScope = 'api://coc00n_api_test/read';
export const apiRedirectUrl = [...apiUrl.split('/').slice(0, 3), '.auth/login/aad'].join('/');
export const appUrl = 'testapp.coc00n.com';
